import smartproBucket from '../../assets/smartpro_bucket.jpeg';
import ceilingpaintBucket from '../../assets/ceilingpaint_bucket.jpeg';
import everlitepremiumemulsionBucket from '../../assets/Everlitepremiumemulsion_bucket.jpeg';
import rubysilkBucket from '../../assets/rubysilk_bucket.jpeg';
import aultraprimerBucket from '../../assets/aultraprimer_bucket.jpeg';
import aultrazioBucket from '../../assets/aultrazio_bucket.jpeg';
import shineadvproBucket from '../../assets/shineadvpro_bucket.jpeg';
import aultrafiveXBucket from '../../assets/aultrafiveX_bucket.jpeg';
import aultramaxBucket from '../../assets/aultramax_bucket.jpeg';
import weatherprotectplusBucket from '../../assets/weatherprotectplus_bucket.jpeg';
import aultraprimeguardBucket from '../../assets/aultraprimeguard_bucket.jpeg';
import aultraadvprimerBucket from '../../assets/aultraadvprimer_bucket.jpeg';
import rainprotectBucket from '../../assets/rainprotect_bucket.jpeg';
import coolpaintBucket from '../../assets/coolpaint_bucket.jpeg';
import rainshieldBucket from '../../assets/rainshield_bucket.jpeg';
import floorguardBucket from '../../assets/floorguard_bucket.jpeg';
import wallputtyBag from '../../assets/wallputty_bag.jpeg';
import wallcareBag from '../../assets/wallcare_bag.jpeg';
import acrylicwallputtyBucket from '../../assets/acrylicwallputty_bucket.jpeg';
import texturefinishPn from '../../assets/texturefinish_pn.jpeg';
import finetextureBag from '../../assets/finetexture_bag.jpeg';
import textureBag from '../../assets/texture_bag.jpeg';
import goldsilver from '../../assets/goldsilver.jpg';
import woodcareputtyTi from '../../assets/woodcareputty_ti.jpeg';
import kpfTin from '../../assets/kpf_tin.jpeg';
import woodprimerBucke from '../../assets/woodprimer_bucke.jpeg';
import metalprimerTin from '../../assets/metalprimer_tin.jpeg';
import yellowprimerTi from '../../assets/yellowprimer_ti.jpeg';
import everliteenamelTin from '../../assets/everliteenamel_tin.jpeg';
import aultramark164Bucket from '../../assets/aultramark164_bucket.jpeg';

export const categories = [
  { id: 1, name: "Interior Emulsions", slug: "interior-emulsions" },
  { id: 2, name: "Exterior Emulsions", slug: "exterior-emulsions" },
  { id: 3, name: "Surface Shields", slug: "protectors" },
  { id: 4, name: "Textures", slug: "textures" },
  { id: 5, name: "Special Products", slug: "special-products" }
];

export const products = [
  // Interior Emulsions & Distemper Category
  // {
  //   id: 1,
  //   name: "Aultra Classic Distemper",
  //   description: "Aultra Paints Acrylic Distemper is formulated with an acrylic co-polymer base. It is environmentally friendly and free from added lead, cadmium, mercury, and arsenic.",
  //   image: smartproBucket,
  //   availablePackings: {
  //     Kgs: ["1", "2", "5", "10", "20"]
  //   },
  //   benefits: ["Environmentally friendly", "Free from heavy metals", "Acrylic co-polymer base"],
  //   category: "Interior Emulsions & Distemper",
  //   categoryId: 1,
  //   usageAreas: ["Interior walls"]
  // },
  {
    id: 2,
    name: "Aultra Smart Pro",
    description: "Aultra Smart Pro Emulsion is the simplest way to upgrade from distempers. It delivers the smooth finish of plastic paint at a price close to that of distemper. With higher coverage, it requires less material and its durability means fewer repaints.",
    image: smartproBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Higher coverage", "Less material required", "Durable finish", "Cost effective"],
    category: "Interior Emulsions & Distemper",
    categoryId: 1,
    usageAreas: ["Interior walls"],
     packaging: "20",
     coats: "2",
     CoverageAreamin: "2400",
     CoverageAreamax: "2800",
  },
  {
    id: 3,
    name: "Aultra Brilliant Ceiling White",
    description: "Aultra Brilliant Ceiling White is a next-generation paint designed for superior light dispersion, delivering a bright and even finish to ceilings.",
    image: ceilingpaintBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Hides undulation", "Highlights interiors", "Supreme whiteness", "Superior light dispersion"],
    category: "Interior Emulsions & Distemper",
    categoryId: 1,
    usageAreas: ["Ceilings"],
    packaging: "20",
     coats: "1",
     CoverageAreamin: "2200",
     CoverageAreamax: "2600",
  },
  {
    id: 4,
    name: "Aultra Everlite",
    description: "For the use of Interiors. Good coverage, luxury finish and cost effective. Clean loose particles, grease, dust and other deposited material before application. Mix water ratio - 3 parts of paint - 2 parts of water. Special polymers & additives are added for long life.",
    image: everlitepremiumemulsionBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Good coverage", "Luxury finish", "Cost effective", "Long life with special polymers"],
    category: "Interior Emulsions & Distemper",
    categoryId: 1,
    usageAreas: ["Interior walls"],
    packaging: "20",
     coats: "2",
     CoverageAreamin: "2600",
     CoverageAreamax: "3000",
  },
  {
    id: 5,
    name: "Aultra Ruby Silk",
    description: "Aultra Paints Ruby Silk Clean Easy Interior Emulsion offers a rich sheen and smooth finish that enhances the elegance of interior walls. Formulated for long-lasting performance, it maintains a 'just painted' look year after year. The washable surface allows easy removal of most stains with a mild soap solution, while its fungus- and mildew-resistant properties help keep your walls looking fresh and clean.",
    image: rubysilkBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Rich sheen", "Smooth finish", "Washable surface", "Fungus and mildew resistant", "Long-lasting performance"],
    category: "Interior Emulsions & Distemper",
    categoryId: 1,
    usageAreas: ["Interior walls"],
    packaging: "20",
     coats: "2",
     CoverageAreamin: "2800",
     CoverageAreamax: "3200",
  },
  {
    id: 6,
    name: "Aultra Primer (Water Based)",
    description: "Aultra primer is suitable for applications interior & exterior surface as an under coat. Add water slowly to the paste to obtain brushing consistency.",
    image: aultraprimerBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Suitable for interior and exterior", "Water-based formula"],
    category: "Interior Emulsions & Distemper",
    categoryId: 1,
    usageAreas: ["Interior and exterior surfaces"],
    packaging: "20",
     coats: "1",
     CoverageAreamin: "2200",
     CoverageAreamax: "2600",
  },
  {
    id: 7,
    name: "Aultra Zio Primer Interior",
    description: "Aultra Zio primer is suitable for applications Interior surface as an under coat. Add water slowly to the paste to obtain brushing consistency.",
    image: aultrazioBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Interior surface primer", "Easy application"],
    category: "Interior Emulsions & Distemper",
    categoryId: 1,
    usageAreas: ["Interior surfaces"],
    packaging: "20",
     coats: "1",
     CoverageAreamin: "2600",
     CoverageAreamax: "3000",
  },

  // Exterior Emulsions Category
  {
    id: 8,
    name: "Aultra Shine Pro",
    description: "Aultra Shine Pro by Aultra Paints is a high-performance, water-based acrylic emulsion, engineered for interior & exterior wall applications.",
    image: shineadvproBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Extra sheen", "Extra coverage", "High-performance", "Water-based acrylic"],
    category: "Exterior Emulsions",
    categoryId: 2,
    usageAreas: ["Interior and exterior walls"],
    packaging: "20",
     coats: "2",
     CoverageAreamin: "2600",
     CoverageAreamax: "3000",
  },
  {
    id: 9,
    name: "Aultra FIVEX",
    description: "Aultra Paints FIVEX (Dust Free) Exterior Emulsion is a water-based, modified acrylic paint that offers water repellency, resistance to dirt, and protection against algae growth. A thicker film build provides effective protection against dampness, while advanced technology ensures exceptional dirt resistance, long-lasting color, and superior opacity.",
    image: aultrafiveXBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Dust free", "Water repellency", "Dirt resistance", "Algae protection", "Dampness protection", "Superior opacity"],
    category: "Exterior Emulsions",
    categoryId: 2,
    usageAreas: ["Exterior walls"],
    packaging: "20",
     coats: "2",
     CoverageAreamin: "1400",
     CoverageAreamax: "1600",
  },
  {
    id: 10,
    name: "Aultra Max Advanced",
    description: "Aultra Max Advanced Exterior Emulsion by Aultra Paints is a high-performance exterior paint known for its superior quality and durability compared to traditional cement paint. It offers excellent resistance to weathering, fading, and moisture, ensuring a long-lasting and visually appealing finish.",
    image: aultramaxBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Superior quality", "Weather resistance", "Fade resistance", "Moisture resistance", "Long-lasting finish"],
    category: "Exterior Emulsions",
    categoryId: 2,
    usageAreas: ["Exterior walls"],
    packaging: "20",
     coats: "2",
     CoverageAreamin: "1500",
     CoverageAreamax: "1800",
  },
  {
    id: 11,
    name: "Aultra Weather Protect Plus",
    description: "Aultra Weather Protect Plus features specially formulated high-performance color pigments and advanced binder technology that provide excellent resistance to ultraviolet radiation. This ensures brighter, cleaner shades that resist fading, keeping your home looking vibrant and beautiful for years to come.",
    image: weatherprotectplusBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["UV resistance", "Fade resistance", "High-performance pigments", "Advanced binder technology", "Long-lasting color"],
    category: "Exterior Emulsions",
    categoryId: 2,
    usageAreas: ["Exterior walls"],
    packaging: "20",
     coats: "2",
     CoverageAreamin: "1500",
     CoverageAreamax: "1700",
  },
  {
    id: 12,
    name: "Aultra Exterior Wall Primer",
    description: "Aultra Advanced Exterior Wall Primer is suitable for applications Exterior surface as an under coat. Add water slowly to the paste to obtain brushing consistency.",
    image: aultraprimeguardBucket,
    availablePackings: {
      Ltr: ["0.5", "1", "4", "10", "20"]
    },
    benefits: ["Exterior surface primer", "Advanced formula"],
    category: "Exterior Emulsions",
    categoryId: 2,
    usageAreas: ["Exterior surfaces"],
    packaging: "20",
     coats: "1",
     CoverageAreamin: "2200",
     CoverageAreamax: "2600",
  },
  {
    id: 13,
    name: "Aultra Primer Advanced",
    description: "Mix 2 parts of water to 3 parts of paint. Easy application & better penetration filling properties. Clean loose particles, grease, dust and other deposited material. After finish coats apply aultra paints emulsions for excellent finish.",
    image: aultraadvprimerBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Easy application", "Better penetration", "Filling properties", "Excellent finish"],
    category: "Exterior Emulsions",
    categoryId: 2,
    usageAreas: ["Interior and exterior surfaces"],
    packaging: "20",
     coats: "1",
     CoverageAreamin: "2200",
     CoverageAreamax: "2600",
  },

  // Protectors - Roof & Walls Category
  {
    id: 14,
    name: "Aultra Rain Protekt",
    description: "Aultra Rain Protekt is for Exterior. Good coverage & matt finish, Cost Effective waterproof product. Add water slowly to the paste to obtain brushing consistency.",
    image: rainprotectBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Waterproof", "Good coverage", "Matt finish", "Cost effective"],
    category: "Protectors - Roof & Walls",
    categoryId: 3,
    usageAreas: ["Exterior walls and roofs"],
    packaging: "20",
     coats: "1",
     CoverageAreamin: "900",
     CoverageAreamax: "1100",
  },
  {
    id: 15,
    name: "Aultra Cool Paint",
    description: "Apply Cool paint Roof Coating to lower the temperature of the building. This reflects more sunlight and absorbs lesser heat. Works effectively in dispelling solar heat on roof and brings down the temperatures. Works to protect and fight back from UV rays and heat produced.",
    image: coolpaintBucket,
    availablePackings: {
      Kgs: ["5", "10"]
    },
    benefits: ["Temperature reduction", "Solar heat reflection", "UV protection", "Heat absorption reduction"],
    category: "Protectors - Roof & Walls",
    categoryId: 3,
    usageAreas: ["Roofs", "Building exteriors"],
    packaging: "10",
     coats: "1",
     CoverageAreamin: "500",
     CoverageAreamax: "600",
  },
  {
    id: 16,
    name: "Aultra Rain Shield Flexo",
    description: "Aultra Paints Rain Shield Flexo is specially formulated to deliver one of the longest-lasting protective finishes, proven to perform reliably under Indian climatic conditions for decades. Enriched with advanced additives, it offers strong resistance to algae, fungi, and bacteria, while protecting against UV degradation and alkali damage.",
    image: rainshieldBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Long-lasting protection", "Algae resistance", "Fungi resistance", "Bacteria resistance", "UV protection", "Alkali damage protection"],
    category: "Protectors - Roof & Walls",
    categoryId: 3,
    usageAreas: ["Walls and roofs"],
    packaging: "20",
     coats: "1",
     CoverageAreamin: "600",
     CoverageAreamax: "800",
  },
  {
    id: 17,
    name: "Aultra Floor Glow Tile & Floor Coat",
    description: "Aultra Floor Glow Tile & Floor Coat is a water-based cross-linking acrylic emulsion that offers superior protection and beauty to cement and concrete-based floors.",
    image: floorguardBucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Superior protection", "Water-based", "Cross-linking acrylic emulsion"],
    category: "Protectors - Roof & Walls",
    categoryId: 3,
    usageAreas: ["Pavement", "Sloping entrances", "Verandahs", "Staircases", "Balcony areas"],
    packaging: "20",
     coats: "1",
     CoverageAreamin: "1700",
     CoverageAreamax: "2100",
  },
  {
    id: 18,
    name: "Aultra Wall Putty (Super fine)",
    description: "Aultra Super fine is a ready-mix base plaster in paste form, made from an acrylic emulsion binder, carefully selected and sieved fillers, and small amounts of performance additives such as thickeners, anti-cracking agents, and biocides. It is suitable for application on RCC and cement walls using either spray equipment or a spatula, providing a smooth and clean surface.",
    image: wallputtyBag,
    availablePackings: {
      Kgs: ["1", "5", "25", "30"]
    },
    benefits: ["Ready-mix", "Anti-cracking agents", "Biocides included", "Smooth finish", "Can be applied with spray equipment"],
    category: "Protectors - Roof & Walls",
    categoryId: 3,
    usageAreas: ["RCC walls", "Cement walls"],
    packaging: "25",
     coats: "2",
     CoverageAreamin: "200",
     CoverageAreamax: "200",
  },
  {
    id: 19,
    name: "Aultra Wall Care",
    description: "Aultra Wall Care is a white cement-based wall putty specially formulated with white cement, selected fillers, and additives. It is used as a putty, filler, and sealer on concrete or mortar walls and ceilings for both interior and exterior applications. The product is water-resistant, adds strength to the walls, and contains fungicides to prevent fungus growth. It does not require water for curing.",
    image: wallcareBag,
    availablePackings: {
      Kgs: ["1", "5", "20", "40"]
    },
    benefits: ["Water-resistant", "Adds wall strength", "Contains fungicides", "No water required for curing", "White cement-based"],
    category: "Protectors - Roof & Walls",
    categoryId: 3,
    usageAreas: ["Concrete walls", "Mortar walls", "Ceilings", "Interior and exterior applications"],
    packaging: "40",
    coats: "2",
    CoverageAreamin: "320",
    CoverageAreamax: "320",
  },
  {
    id: 20,
    name: "Aultra Acrylic Wall Putty",
    description: "Acrylic Polymer Based Putty For Exterior & Interior. Add water and stir 25-30% for easy application. 2 coats of application for smooth finish.",
    image: acrylicwallputtyBucket,
    availablePackings: {
      Kgs: ["1", "2", "5", "10", "20"]
    },
    benefits: ["Acrylic polymer based", "Easy application", "Smooth finish with 2 coats", "Suitable for interior and exterior"],
    category: "Protectors - Roof & Walls",
    categoryId: 3,
    usageAreas: ["Interior and exterior walls"],
    packaging: "20",
     coats: "1",
     CoverageAreamin: "260",
     CoverageAreamax: "300",
  },

  // Textures Category
  {
    id: 21,
    name: "Aultra Texture Finish",
    description: "Aultra Texture (Acrylic) is a ready-to-use paste made from natural fine quartz, designed to create textured finishes with lines or circles based on customer preference. The texture can be small or medium in size and is available in a base color.",
    image: texturefinishPn,
    availablePackings: {
      Kgs: ["25", "30"]
    },
    benefits: ["Ready-to-use", "Natural fine quartz", "Customizable patterns", "Small or medium texture size"],
    category: "Textures",
    categoryId: 4,
    usageAreas: ["Interior and exterior walls"]
  },
  {
    id: 22,
    name: "Aultra Fine Texture",
    description: "Aultra fine texture coating formulated with a tough, durable acrylic copolymer resin, alkali-resistant pigments. It is reinforced with selected mineral quartz and mica, and includes fungicides and algaecides to enhance weather resistance. Its high-build composition effectively conceals hairline cracks and surface irregularities.",
    image: finetextureBag,
    availablePackings: {
      Kgs: ["25"]
    },
    benefits: ["Tough and durable", "Alkali-resistant pigments", "Contains fungicides and algaecides", "Conceals hairline cracks", "Weather resistant"],
    category: "Textures",
    categoryId: 4,
    usageAreas: ["Interior and exterior walls"]
  },
  {
    id: 23,
    name: "Aultra Natural Grit Texture",
    description: "Aultra Natural Grit Texture is a decorative thick, granular marble chips texture wall coating, created by marble and stone chips, in a range of natural colors with a permanent shade life. It is highly resistant to alkalis and acids, with excellent adhesion and durability on all absorbent surfaces.",
    image: textureBag,
    availablePackings: {
      Kgs: ["5", "10", "25", "30"]
    },
    benefits: ["Decorative marble chips", "Natural colors", "Permanent shade life", "Alkali and acid resistant", "Excellent adhesion"],
    category: "Textures",
    categoryId: 4,
    usageAreas: ["Interior and exterior walls", "All absorbent surfaces"]
  },

  // Special Products Category
  {
    id: 24,
    name: "Aultra Gold & Silver Colour",
    description: "Gold and silver metallic paints are versatile materials for art and craft, providing a rich, reflective finish that resembles the shine of real metal.",
    image: goldsilver,
    availablePackings: {
      ml: ["50", "100", "200", "500"],
      Ltr: ["1", "2", "10", "20"]
    },
    benefits: ["Metallic finish", "Rich reflective shine", "Versatile for art and craft"],
    category: "Special Products",
    categoryId: 5,
    usageAreas: ["Art and craft", "Decorative purposes"]
  },
  {
    id: 25,
    name: "Aultra Wood Care Putty",
    description: "Aultra Paints WoodTech Filler for Interiors and Exteriors is a water-based dent and grain filler offering excellent surface smoothness and high hardness",
    image: woodcareputtyTi,
    availablePackings: {
      Kgs: ["1", "2", "5", "10", "20"]
    },
    benefits: [],
    category: "Special Products",
    categoryId: 5,
    usageAreas: ["Wood surfaces"]
  },
  {
    id: 26,
    name: "Aultra KPF (Knifing Paste Filler)",
    description: "Aultra  Paints Knifing Paste Filler is ideal for filling dents and surface imperfections on metal and wooden surfaces, ensuring a smooth and flawless finish. ",
    image: kpfTin,
    availablePackings: {
      Kgs: ["1", "2", "5", "20", "35"]
    },
    benefits: [],
    category: "Special Products",
    categoryId: 5,
    usageAreas: []
  },
  {
    id: 27,
    name: "Aultra Wood Primer",
    description: "Aultra Paints Wood Primer is a specially formulated undercoat for wooden surfaces that ensures strong adhesion and enhances the durability and finish of the topcoat.",
    image: woodprimerBucke,
    availablePackings: {
      ml: ["500"],
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: [],
    category: "Special Products",
    categoryId: 5,
    usageAreas: ["Wood surfaces"]
  },
  {
    id: 28,
    name: "Aultra Metal Primer",
    description: "Metal primer improves adhesion and prevents rust, while enamel paints provide a durable, glossy, and moisture-resistant finish.",
    image: metalprimerTin,
    availablePackings: {
      ml: ["500"],
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Improves adhesion", "Prevents rust", "Durable finish", "Moisture-resistant"],
    category: "Special Products",
    categoryId: 5,
    usageAreas: ["Metal surfaces"]
  },
  {
    id: 29,
    name: "Aultra Yellow Primer",
    description: "Aultra Paints Yellow Metal Primer offers superior rust protection, keeping metal surfaces corrosion-free and looking beautiful for a longer time.",
    image: yellowprimerTi,
    availablePackings: {
      ml: ["500"],
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: [],
    category: "Special Products",
    categoryId: 5,
    usageAreas: []
  },
  {
    id: 30,
    name: "Aultra Everlite Premium Enamel",
    description: "Aultra Paints Everlite Premium Enamel gives surfaces a glossy, fresh appearance while forming a durable film that resists household stains, providing lasting protection and shine.",
    image: everliteenamelTin, 
    availablePackings: {
      ml: ["500"],
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Premium quality", "Glossy finish"],
    category: "Special Products",
    categoryId: 5,
    usageAreas: []
  },
  {
    id: 31,
    name: "Aultra MARK 164 (Road & Kerb)",
    description: "A fast-drying, water-repellent coating formulated with modified acrylic resin, enriched with Titanium Dioxide and high-performance, color-fast pigments. Designed for durability, it offers outstanding resistance to abrasion and chemicals, making it ideal for marking concrete and asphalt runways.",
    image: aultramark164Bucket,
    availablePackings: {
      Ltr: ["1", "4", "10", "20"]
    },
    benefits: ["Fast-drying", "Water-repellent", "Abrasion resistant", "Chemical resistant", "Color-fast pigments"],
    category: "Special Products",
    categoryId: 5,
    usageAreas: ["Concrete", "Asphalt", "Paving blocks", "Kerbs", "Interior and exterior"]
  }
];

// Helper functions remain the same
export const getProductsByCategory = (categoryId) => {
  return products.filter(product => product.categoryId === categoryId);
};

export const getProductById = (productId) => {
  return products.find(product => product.id === productId);
};

export const getCategoryById = (categoryId) => {
  return categories.find(category => category.id === categoryId);
};

export const searchProducts = (searchTerm) => {
  const term = searchTerm.toLowerCase();
  return products.filter(product => 
    product.name.toLowerCase().includes(term) ||
    product.description.toLowerCase().includes(term) ||
    product.category.toLowerCase().includes(term) ||
    product.benefits.some(benefit => benefit.toLowerCase().includes(term))
  );
};

export const getProductsByPackagingUnit = (unit) => {
  return products.filter(product => 
    product.availablePackings[unit] && product.availablePackings[unit].length > 0
  );
};

export const getPackingsByUnit = (product, unit) => {
  return product.availablePackings[unit] || [];
};

export const getPackagingDisplay = (product) => {
  return Object.entries(product.availablePackings)
    .map(([unit, sizes]) => `${sizes.join(", ")} ${unit}`)
    .join(" | ");
};

export const hasMixedPackaging = (product) => {
  return Object.keys(product.availablePackings).length > 1;
};

export const getAvailableUnits = (product) => {
  return Object.keys(product.availablePackings);
};

export const getAvailableProducts = () => {
  return products.filter(product => 
    Object.values(product.availablePackings).some(packings => packings.length > 0)
  );
};
